<template>
  <div :style="`width: ${uploadStyleWH[0]};height: ${uploadStyleWH[1]}`" class="upload_class">
    <div class="demo-upload-list" :style="`width: ${uploadImgStyleWH[0]};height: ${uploadImgStyleWH[1]};line-height: ${uploadImgStyleWH[1]};`" v-for="(item, index) in defaultData" :key="index">
      <img :src="item.url" />
      <div class="demo-upload-list-cover">
        <Icon type="ios-eye-outline" @click="handleView(item)"></Icon>
        <Icon type="ios-trash-outline" @click="handleRemove(item)"></Icon>
      </div>
    </div>
    <div class="demo-upload-list" :style="`width: ${uploadImgStyleWH[0]};height: ${uploadImgStyleWH[1]};line-height: ${uploadImgStyleWH[1]};`" v-if="upShow">
      <Spin fix></Spin>
    </div>
    <Upload
      :ref="uploadKey"
      :action="actionUrl"
      :data="data"
      :default-file-list="multiple ? defaultDatas : defaultData"
      :headers="headersUrl"
      :on-success="handleSuccess"
      :on-error="handleError"
      :format="formatData"
      :max-size="maxSize"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :on-progress="_handleProgress"
      :show-upload-list="showUploadList"
      :multiple="multiple"
      :before-upload="handleBeforeUpload"
      :type="type"
      v-if="defaultData.length < multipleLength"
    >
      <slot v-if="!upShow"></slot>
    </Upload>
    <Modal title="查看图片" v-model="visible">
      <img :src="lookImg" v-if="visible" style="width: 100%" />
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'upload_con',
  data() {
    return {
      visible: false, // 查看图片弹框
      lookImg: '', // 查看的图片
      upShow: false,
      defaultDatas: undefined
    }
  },
  props: {
    // 文件上传接口
    actionUrl: {
      type: String,
      default: ''
    },
    // 文件上传接口 headers
    headersUrl: {
      type: Object,
      default: null
    },
    data: {
      // 上传时额外携带的参数
      type: Object,
      default: null
    },
    defaultData: {
      // 默认展示列表
      type: Array,
      default: null
    },
    // 是否显示已上传列表
    showUploadList: {
      type: Boolean,
      default: true
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 文件上传限制格式
    formatData: {
      type: Array,
      default: []
    },
    // 文件上传限制大小
    maxSize: {
      type: Number,
      default: 2048
    },
    // 文件上传数量
    multipleLength: {
      type: Number,
      default: 5
    },
    // 上传控件的类型，可选值为 select（点击选择），drag（支持拖拽）
    type: {
      type: String,
      default: 'drag'
    },
    // 组件宽高样式
    uploadStyleWH: {
      type: Array,
      default: []
    },
    // 图片的宽高
    uploadImgStyleWH: {
      type: Array,
      default: []
    },

    // 上传图片返回图片的 key 名
    uploadKey: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 文件上传时参数
    _handleProgress(event, file, fileList) {
      this.upShow = true
    },
    // 上传成功回调
    handleSuccess(res, file) {
      this.upShow = false
      if (res.success) {
        res.key = this.uploadKey
        this.$emit('handleSuccess', res, file)
      } else {
        this.$Message.error(res.message)
      }
    },
    // 上传失败回调
    handleError(error, file, fileList) {
      this.upShow = false
      this.$Message.error(error.toString())
    },
    // 文件格式校验失败回调
    handleFormatError(file) {
      this.$Notice.warning({
        title: '不支持的文件格式',
        desc: '所选文件‘ ' + file.name + `’格式不正确, 请选择 ${this.formatData.join(',')} 格式文件`
      })
    },
    // 文件大小校验钩子
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小过大',
        desc: '所选文件‘ ' + file.name + ' ’大小过大, 不得超过' + parseInt(this.maxSize / 1024) + 'M'
      })
    },

    // 清楚文件列表
    handleClearFiles(refValue) {
      this.$refs[refValue].clearFiles()
    },
    // 限制上传数量 文件上传之前调用 理论上用不到
    handleBeforeUpload() {
      const check = this.defaultData.length < this.multipleLength
      if (!check) {
        this.$Notice.warning({
          title: '上传数量限制',
          desc: '最多只能上传 ' + this.multipleLength + '个' + this.formatData.join(',') + '格式的文件'
        })
      }
      return check
    },
    // 删除图片
    handleRemove(e) {
      this.$emit('handleRemImgList', e)
    },
    // 查看图片
    handleView(e) {
      this.lookImg = e.url
      this.visible = true
    }
  },
  mounted() {},
  computed: {}
}
</script>
<style scoped>
.upload_class {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.demo-upload-list {
  float: left;
  text-align: center;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 5px;
  margin-bottom: 5px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/upload-con/uploadCon.vue